import { TextField, TextFieldProps } from "@mui/material"
import { useEffect, useState } from "react"

interface NexTextFieldProps extends Omit<TextFieldProps, "onChange"> {
    onChange: (value: string) => void
}

export const NexTextField = (props: NexTextFieldProps) => {
    const { onChange, value, ...restProps } = props
    const val = typeof value === "string" ? value : ""

    const [inputValue, setInputValue] = useState<string>(val)

    useEffect(() => {
        setInputValue(val)
    }, [val])

    return (
        <TextField
            {...restProps}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onBlur={() => onChange(inputValue)}
            variant="outlined"
        />
    )
}
